export const getIsSendbirdUserLoading = state => state.sendbird.get('loading');
export const getSendbirdUser = state => state.sendbird.get('sendbirdUser');
export const getSendbirdChannel = state => state.sendbird.get('sendbirdChannel');
export const getSendbirdChannelLoading = state => state.sendbird.get('channelLoading');
export const getSendbirdChannelURL = state => state.sendbird.get('sendbirdChannelURL');



/** WEBPACK FOOTER **
 ** ./src/selectors/sendbird-selectors.js
 **/